import { Product } from '@wconcept/wconcept-common/models/renewal/product';
import RelatedPrdItem from '@wconcept/wconcept-ui-renewal/src/components/molecules/_item/RelatedPrdItem';

function RelatedProducts({
  isDesktop,
  products,
  total = 0,
  rs,
  visibleCount,
  priority,
  isShow,
  onClick,
  onMoreClick,
}: {
  isDesktop?: boolean;
  rs?: string;
  products: Product[];
  visibleCount: number;
  priority?: boolean;
  onClick?: (product: Product, index: number) => void;
  onMoreClick?: () => void;
  total?: number;
  isShow?: boolean;
}) {
  if (isDesktop && !isShow) {
    return null;
  }

  return (
    <>
      {products.map((v, i) => (
        <RelatedPrdItem
          rs={rs}
          priority={priority}
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          imgSrc={v.productImageUrl}
          total={
            i + 1 === products?.length &&
            products.length >= visibleCount &&
            total > visibleCount
              ? total - products.length + 1
              : undefined
          }
          onClick={() => {
            if (i + 1 === products?.length && total - products.length > 0) {
              onMoreClick?.();
              return;
            }
            onClick?.(v, i);
          }}
        />
      ))}
    </>
  );
}

export default RelatedProducts;
